import React from 'react';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import Problems from './components/Problems';
import Features from './components/Features';
import Reports from './components/Reports';
import KeyFeatures from './components/KeyFeatures';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App min-h-screen bg-gradient-subtle">
      <Header />
      <main>
        <Hero />
        <Problems />
        <Features />
        <Reports />
        <KeyFeatures />
        <Pricing />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;